export const FAVORITES_OVERVIEW_FORM = 'favoritesOverviewForm';
export const FAVORITE_TYPE_LIKE = 'LIKE';
export const FAVORITE_TYPE_DISLIKE = 'DISLIKE';
export const FAVORITED_ON_DESC_SORT = 'favoritedOn.desc';
